(function () {
  if (customElements.get('complete-the-set')) return;

  function formatMoney(cents) {
    var t = window.theme || {};
    var format = t.money_format_with_product_code_preference || t.money_format || '${{amount}}';
    if (t.Shopify && typeof t.Shopify.formatMoney === 'function') {
      return t.Shopify.formatMoney(cents, format);
    }
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      if (key === 'amount_no_decimals') return withCommas;
      if (key === 'amount_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
      if (key === 'amount_no_decimals_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return withCommas + '.' + parts[1];
    });
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  class CompleteTheSet extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.status = this.querySelector('[data-cts-status]');
      this.totalEl = this.querySelector('[data-cts-total]');
      this.addAllButton = this.querySelector('[data-cts-add-all]');
      this.mainProduct = this.readMainProduct();

      this.pieces = Array.prototype.map.call(this.querySelectorAll('[data-cts-item]'), (item) => {
        var json = item.querySelector('[data-cts-variants]');
        var productJson = item.querySelector('[data-cts-product]');
        var productData = null;
        try {
          productData = productJson ? JSON.parse(productJson.textContent) : null;
        } catch (e) {
          productData = null;
        }
        var piece = {
          product: productData,
          el: item,
          variants: json ? JSON.parse(json.textContent) : [],
          options: Array.prototype.slice.call(item.querySelectorAll('[data-cts-option]')),
          price: item.querySelector('[data-cts-price]'),
          packTotal: item.querySelector('[data-cts-pack-total]'),
          pack: Math.max(1, parseInt(item.dataset.packQty, 10) || 1),
          image: item.querySelector('.cts__image'),
          button: item.querySelector('[data-cts-add]'),
          variant: null
        };
        item.addEventListener('change', () => this.updatePiece(piece));
        if (piece.button) {
          piece.button.addEventListener('click', () => this.addPiece(piece));
        }
        item.querySelectorAll('[data-cts-quick-view]').forEach((trigger) => {
          trigger.addEventListener('click', (event) => {
            // Let ctrl/cmd/shift-click on links open the product page as usual.
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;
            if (!piece.product) return;
            event.preventDefault();
            this.openModal(piece, trigger);
          });
        });
        this.updatePiece(piece);
        return piece;
      });

      if (this.addAllButton) {
        this.addAllButton.addEventListener('click', () => this.addFullSet());
      }

      this.onMainChange = (event) => {
        var form = this.getMainForm();
        if (form && form.contains(event.target)) {
          window.setTimeout(() => this.updateTotal(), 0);
        }
      };
      document.addEventListener('change', this.onMainChange);
      document.addEventListener('input', this.onMainChange);
      // The theme's quantity +/- buttons update the field through jQuery, which
      // doesn't fire native change events, so listen for those clicks as well.
      this.onQuantityClick = (event) => {
        var form = this.getMainForm();
        if (form && event.target.closest && event.target.closest('[data-quantity]') && form.contains(event.target)) {
          window.setTimeout(() => this.updateTotal(), 0);
        }
      };
      document.addEventListener('click', this.onQuantityClick);
      this.updateTotal();
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.onMainChange);
      document.removeEventListener('input', this.onMainChange);
      document.removeEventListener('click', this.onQuantityClick);
      if (this.modal) {
        this.closeModal(true);
        this.modal.remove();
        this.modal = null;
      }
    }

    readMainProduct() {
      var el = document.getElementById('ProductJson-' + this.dataset.mainProductId);
      try {
        return el ? JSON.parse(el.textContent) : null;
      } catch (e) {
        return null;
      }
    }

    getMainForm() {
      var form = document.getElementById(this.dataset.productFormId);
      if (form) return form;
      var container = this.closest('.product-form');
      return container ? container.querySelector('.product-purchase-form') : null;
    }

    getMainVariant() {
      var form = this.getMainForm();
      if (!form || !this.mainProduct) return null;
      var input = form.querySelector('[name="id"]');
      var id = input ? parseInt(input.value, 10) : NaN;
      if (!id) return null;
      return this.mainProduct.variants.find((v) => v.id === id) || null;
    }

    getMainQuantity() {
      var form = this.getMainForm();
      var input = form ? form.querySelector('[name="quantity"]') : null;
      var qty = input ? parseInt(input.value, 10) : 1;
      return qty > 0 ? qty : 1;
    }

    selectedOptions(piece) {
      return piece.options.map((fieldset) => {
        var checked = fieldset.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    findVariant(piece, selected) {
      if (!piece.options.length) return piece.variants[0] || null;
      return piece.variants.find((v) => selected.every((value, i) => v.options[i] === value)) || null;
    }

    updatePiece(piece) {
      var selected = this.selectedOptions(piece);
      piece.variant = this.findVariant(piece, selected);

      piece.options.forEach((fieldset, index) => {
        var label = fieldset.querySelector('[data-cts-option-value]');
        if (label) label.textContent = selected[index] || '';
        fieldset.querySelectorAll('input').forEach((input) => {
          var test = selected.slice();
          test[index] = input.value;
          var match = piece.variants.find((v) => test.every((value, i) => v.options[i] === value));
          input.classList.toggle('is-unavailable', !match || !match.available);
        });
      });

      var v = piece.variant;
      if (piece.price) {
        piece.price.textContent = v ? formatMoney(v.price) : '';
      }
      if (piece.packTotal) {
        piece.packTotal.textContent = v ? formatMoney(v.price * piece.pack) : '';
      }
      if (v && v.image && piece.image && piece.image.tagName === 'IMG') {
        piece.image.src = v.image;
        if (v.srcset) piece.image.srcset = v.srcset;
      }
      if (piece.button) {
        var available = !!(v && v.available);
        piece.button.disabled = !available;
        piece.button.textContent = available ? piece.button.dataset.label : this.dataset.textSoldOut;
      }
      if (this.modalPiece === piece) this.syncModal();
      this.updateTotal();
    }

    updateTotal() {
      if (!this.pieces) return;
      var main = this.getMainVariant();
      var total = main ? main.price * this.getMainQuantity() : 0;
      var allAvailable = !!(main && main.available);
      this.pieces.forEach((piece) => {
        if (piece.variant) total += piece.variant.price * piece.pack;
        if (!piece.variant || !piece.variant.available) allAvailable = false;
      });
      if (this.totalEl) this.totalEl.textContent = formatMoney(total);
      if (this.addAllButton && !this.addAllButton.classList.contains('is-loading')) {
        this.addAllButton.disabled = !allAvailable;
        this.addAllButton.title = allAvailable ? '' : (!main || !main.available ? this.dataset.textChooseOptions : this.dataset.textUnavailable);
      }
    }

    setStatus(html) {
      if (this.status) this.status.innerHTML = html;
    }

    addPiece(piece) {
      if (!piece.variant || !piece.variant.available) return;
      this.addItems([{ id: piece.variant.id, quantity: piece.pack }], piece.button);
    }

    addFullSet() {
      var main = this.getMainVariant();
      if (!main || !main.available) {
        this.setStatus(escapeHtml(this.dataset.textChooseOptions));
        return;
      }
      var items = [{ id: main.id, quantity: this.getMainQuantity() }];
      for (var i = 0; i < this.pieces.length; i++) {
        var v = this.pieces[i].variant;
        if (!v || !v.available) {
          this.setStatus(escapeHtml(this.dataset.textUnavailable));
          return;
        }
        items.push({ id: v.id, quantity: this.pieces[i].pack });
      }
      this.addItems(items, this.addAllButton);
    }

    addItems(items, button, statusEl) {
      var t = window.theme || {};
      var url = (t.routes && t.routes.cart_add_url) || ((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js');
      var useDrawer = !!(t.settings && t.settings.cart_type === 'drawer' && window.jQuery);
      var body = { items: items };
      if (useDrawer) body.sections = 'cart-drawer';

      var label = button.dataset.label;
      button.disabled = true;
      button.classList.add('is-loading');
      button.textContent = this.dataset.textAdding;
      var setStatus = (html) => {
        if (statusEl) {
          statusEl.innerHTML = html;
        } else {
          this.setStatus(html);
        }
      };
      setStatus('');

      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then((res) => res.json().then((data) => ({ ok: res.ok, data: data })))
        .then((result) => {
          if (!result.ok) {
            throw new Error(result.data.description || result.data.message || 'Error');
          }
          document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false }));
          if (statusEl && useDrawer && this.modal) this.closeModal();
          var shown = useDrawer && this.showCartDrawer(result.data);
          button.textContent = this.dataset.textAdded;
          if (!shown) {
            setStatus(escapeHtml(this.dataset.textAdded) + ' &middot; <a href="' + this.dataset.cartUrl + '">' + escapeHtml(this.dataset.textCart) + '</a>');
          }
          window.setTimeout(() => {
            button.textContent = label;
            button.classList.remove('is-loading');
            this.pieces.forEach((piece) => this.updatePiece(piece));
          }, 2500);
        })
        .catch((error) => {
          button.textContent = label;
          button.classList.remove('is-loading');
          this.pieces.forEach((piece) => this.updatePiece(piece));
          setStatus(escapeHtml(error.message));
        });
    }


    // ---------- Quick view ----------

    buildModal() {
      if (this.modal) return this.modal;
      var uid = 'cts-modal-' + Math.random().toString(36).slice(2, 8);
      var modal = document.createElement('div');
      modal.className = 'cts-modal';
      modal.hidden = true;
      modal.setAttribute('style', this.getAttribute('style') || '');
      modal.innerHTML =
        '<div class="cts-modal__overlay" data-cts-close></div>' +
        '<div class="cts-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="' + uid + '-title" tabindex="-1">' +
          '<button type="button" class="cts-modal__close" data-cts-close aria-label="' + escapeHtml(this.dataset.textClose || 'Close') + '">' +
            '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.6" fill="none"/></svg>' +
          '</button>' +
          '<div class="cts-modal__grid">' +
            '<div class="cts-modal__gallery">' +
              '<div class="cts-modal__main"><img class="cts-modal__image" alt="" sizes="(max-width: 767px) 100vw, 480px"></div>' +
              '<div class="cts-modal__thumbs"></div>' +
            '</div>' +
            '<div class="cts-modal__details">' +
              '<h2 class="cts-modal__title" id="' + uid + '-title"></h2>' +
              '<div class="cts-modal__price"><span data-m-price></span> <span class="cts__pack" data-m-pack></span></div>' +
              '<div class="cts-modal__options"></div>' +
              '<p class="cts-modal__description" data-m-description></p>' +
              '<div class="cts-modal__buy">' +
                '<label class="cts-modal__qty-label" for="' + uid + '-qty">' + escapeHtml(this.dataset.textQuantity || 'Quantity') + '</label>' +
                '<div class="cts-modal__qty">' +
                  '<button type="button" class="cts-modal__qty-btn" data-m-qty="down" aria-label="-">&minus;</button>' +
                  '<input type="number" inputmode="numeric" id="' + uid + '-qty" class="cts-modal__qty-input" data-m-qty-input>' +
                  '<button type="button" class="cts-modal__qty-btn" data-m-qty="up" aria-label="+">+</button>' +
                '</div>' +
                '<button type="button" class="cts__add cts-modal__add" data-m-add></button>' +
              '</div>' +
              '<p class="cts__status" role="status" aria-live="polite" data-m-status></p>' +
              '<a class="cts-modal__full" data-m-full></a>' +
            '</div>' +
          '</div>' +
        '</div>';
      document.body.appendChild(modal);

      this.modal = modal;
      this.modalEls = {
        dialog: modal.querySelector('.cts-modal__dialog'),
        image: modal.querySelector('.cts-modal__image'),
        thumbs: modal.querySelector('.cts-modal__thumbs'),
        title: modal.querySelector('.cts-modal__title'),
        price: modal.querySelector('[data-m-price]'),
        pack: modal.querySelector('[data-m-pack]'),
        options: modal.querySelector('.cts-modal__options'),
        description: modal.querySelector('[data-m-description]'),
        qty: modal.querySelector('[data-m-qty-input]'),
        add: modal.querySelector('[data-m-add]'),
        status: modal.querySelector('[data-m-status]'),
        full: modal.querySelector('[data-m-full]')
      };

      modal.addEventListener('click', (event) => {
        if (event.target.closest('[data-cts-close]')) {
          this.closeModal();
          return;
        }
        var thumb = event.target.closest('[data-m-thumb]');
        if (thumb) {
          this.showImage(parseInt(thumb.dataset.mThumb, 10));
          return;
        }
        var step = event.target.closest('[data-m-qty]');
        if (step) {
          var pack = this.modalPiece ? this.modalPiece.pack : 1;
          var current = this.normaliseQty(this.modalEls.qty.value);
          this.modalEls.qty.value = step.dataset.mQty === 'up' ? current + pack : Math.max(pack, current - pack);
        }
      });
      this.modalEls.qty.addEventListener('change', () => {
        this.modalEls.qty.value = this.normaliseQty(this.modalEls.qty.value);
      });
      this.modalEls.options.addEventListener('change', (event) => {
        var input = event.target;
        if (!this.modalPiece || !input.matches('input[type="radio"]')) return;
        var fieldset = this.modalPiece.options[parseInt(input.dataset.optionIndex, 10)];
        var rowInput = fieldset && fieldset.querySelectorAll('input')[parseInt(input.dataset.valueIndex, 10)];
        if (rowInput) {
          rowInput.checked = true;
          this.updatePiece(this.modalPiece);
        }
      });
      this.modalEls.add.addEventListener('click', () => {
        var piece = this.modalPiece;
        if (!piece || !piece.variant || !piece.variant.available) return;
        var qty = this.normaliseQty(this.modalEls.qty.value);
        this.modalEls.qty.value = qty;
        this.addItems([{ id: piece.variant.id, quantity: qty }], this.modalEls.add, this.modalEls.status);
      });
      modal.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.closeModal();
        } else if (event.key === 'Tab') {
          this.trapFocus(event);
        }
      });
      return modal;
    }

    normaliseQty(value) {
      var pack = this.modalPiece ? this.modalPiece.pack : 1;
      var qty = parseInt(value, 10);
      if (!qty || qty < pack) return pack;
      return Math.ceil(qty / pack) * pack;
    }

    trapFocus(event) {
      var focusable = Array.prototype.filter.call(
        this.modalEls.dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
        (el) => el.offsetWidth || el.offsetHeight || el.getClientRects().length
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === this.modalEls.dialog)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    openModal(piece, trigger) {
      this.buildModal();
      var els = this.modalEls;
      var product = piece.product;
      this.modalPiece = piece;
      this.modalTrigger = trigger;

      els.title.textContent = product.title;
      els.description.textContent = product.description || '';
      els.description.hidden = !product.description;
      els.full.href = product.url;
      els.full.textContent = this.dataset.textFullDetails || 'View full details';
      els.status.innerHTML = '';
      els.qty.min = piece.pack;
      els.qty.step = piece.pack;
      els.qty.value = piece.pack;
      els.add.dataset.label = this.dataset.textAddToCart || 'Add to cart';
      els.add.classList.remove('is-loading');

      // Gallery
      this.modalImages = product.images || [];
      els.thumbs.innerHTML = this.modalImages.length > 1 ? this.modalImages.map((img, i) =>
        '<button type="button" class="cts-modal__thumb" data-m-thumb="' + i + '" aria-label="' + escapeHtml(img.alt || product.title) + ' (' + (i + 1) + '/' + this.modalImages.length + ')">' +
          '<img src="' + img.thumb + '" alt="" loading="lazy">' +
        '</button>'
      ).join('') : '';

      // Options: mirror the row's option markup so swatches and sold-out states match.
      els.options.innerHTML = '';
      piece.options.forEach((fieldset, optionIndex) => {
        var legend = fieldset.querySelector('legend');
        var name = legend ? legend.firstChild.textContent.replace(/:\s*$/, '').trim() : '';
        var newFieldset = document.createElement('fieldset');
        newFieldset.className = 'cts__option';
        newFieldset.innerHTML = '<legend class="cts__option-label">' + escapeHtml(name) + ': <span data-m-option-value></span></legend><div class="cts__values"></div>';
        var values = newFieldset.querySelector('.cts__values');
        fieldset.querySelectorAll('input').forEach((rowInput, valueIndex) => {
          var rowLabel = fieldset.querySelector('label[for="' + rowInput.id + '"]');
          var id = this.modal.querySelector('.cts-modal__title').id + '-o' + optionIndex + '-' + valueIndex;
          var input = document.createElement('input');
          input.type = 'radio';
          input.className = 'cts__radio';
          input.id = id;
          input.name = id.replace(/-\d+$/, '');
          input.value = rowInput.value;
          input.dataset.optionIndex = optionIndex;
          input.dataset.valueIndex = valueIndex;
          var label = document.createElement('label');
          label.htmlFor = id;
          label.className = rowLabel ? rowLabel.className : 'cts__value';
          label.title = rowInput.value;
          if (rowLabel && rowLabel.getAttribute('style')) label.setAttribute('style', rowLabel.getAttribute('style'));
          label.innerHTML = '<span class="cts__value-text">' + escapeHtml(rowInput.value) + '</span>';
          values.appendChild(input);
          values.appendChild(label);
        });
        els.options.appendChild(newFieldset);
      });

      this.syncModal(true);

      this.modal.hidden = false;
      document.documentElement.classList.add('cts-modal-open');
      window.requestAnimationFrame(() => {
        this.modal.classList.add('is-open');
        els.dialog.focus();
      });
    }

    syncModal(forceImage) {
      var piece = this.modalPiece;
      if (!piece || !this.modal) return;
      var els = this.modalEls;
      var v = piece.variant;
      var modalFieldsets = els.options.querySelectorAll('fieldset');

      piece.options.forEach((fieldset, optionIndex) => {
        var target = modalFieldsets[optionIndex];
        if (!target) return;
        var rowInputs = fieldset.querySelectorAll('input');
        var modalInputs = target.querySelectorAll('input');
        var selectedValue = '';
        rowInputs.forEach((rowInput, i) => {
          if (!modalInputs[i]) return;
          modalInputs[i].checked = rowInput.checked;
          modalInputs[i].classList.toggle('is-unavailable', rowInput.classList.contains('is-unavailable'));
          if (rowInput.checked) selectedValue = rowInput.value;
        });
        var valueLabel = target.querySelector('[data-m-option-value]');
        if (valueLabel) valueLabel.textContent = selectedValue;
      });

      els.price.textContent = v ? formatMoney(v.price) : '';
      if (piece.pack > 1 && v) {
        var packText = (this.dataset.textPack || 'Pack of [qty]').replace('[qty]', piece.pack);
        els.pack.textContent = '\u00b7 ' + packText + ' \u00b7 ' + formatMoney(v.price * piece.pack);
      } else {
        els.pack.textContent = '';
      }

      var imageIndex = -1;
      if (v && v.media_id) {
        imageIndex = this.modalImages.findIndex((img) => img.id === v.media_id);
      }
      if (imageIndex > -1) {
        this.showImage(imageIndex);
      } else if (forceImage) {
        this.showImage(0);
      }

      if (!els.add.classList.contains('is-loading')) {
        var available = !!(v && v.available);
        els.add.disabled = !available;
        els.add.textContent = available ? els.add.dataset.label : this.dataset.textSoldOut;
      }
    }

    showImage(index) {
      var els = this.modalEls;
      var img = this.modalImages[index];
      if (!img) {
        els.image.removeAttribute('src');
        els.image.removeAttribute('srcset');
        els.image.hidden = true;
        return;
      }
      els.image.hidden = false;
      els.image.src = img.src;
      els.image.srcset = img.srcset;
      els.image.alt = img.alt || '';
      els.image.style.aspectRatio = img.ratio || '';
      els.thumbs.querySelectorAll('[data-m-thumb]').forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === index);
        thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    closeModal(silent) {
      if (!this.modal || this.modal.hidden) return;
      this.modal.classList.remove('is-open');
      this.modal.hidden = true;
      document.documentElement.classList.remove('cts-modal-open');
      var trigger = this.modalTrigger;
      this.modalPiece = null;
      this.modalTrigger = null;
      if (!silent && trigger) {
        var focusTarget = trigger.getAttribute('tabindex') === '-1'
          ? trigger.closest('[data-cts-item]').querySelector('.cts__quick-link')
          : trigger;
        if (focusTarget) focusTarget.focus();
      }
    }

    showCartDrawer(data) {
      try {
        var $ = window.jQuery;
        var html = data.sections && data.sections['cart-drawer'];
        if (!html) return false;
        var keys = (data.items || [data]).map((item) => item.key);
        if (window.theme && typeof window.theme.removeAddedCartDrawer === 'function') {
          window.theme.removeAddedCartDrawer();
        }
        var $container = $(html);
        var drawer = $container.find('.cart-summary-overlay')[0];
        if (!drawer) return false;
        drawer.classList.add('cart-summary-overlay--off-screen');
        $container.find('.cart-summary-overlay__row-body').each(function () {
          if (keys.indexOf(this.getAttribute('data-item-key')) === -1) $(this).remove();
        });
        var shopMore = drawer.querySelector('.shop-more');
        if (shopMore) {
          shopMore.addEventListener('click', function (evt) {
            evt.preventDefault();
            window.theme.removeAddedCartDrawer();
          });
        }
        $container.prependTo('body');
        window.setTimeout(function () {
          drawer.classList.remove('cart-summary-overlay--off-screen');
        }, 50);
        return true;
      } catch (e) {
        return false;
      }
    }
  }

  customElements.define('complete-the-set', CompleteTheSet);
})();
